import { render, staticRenderFns } from "./ProjectGalleryDialog.vue?vue&type=template&id=0223c0b2&scoped=true&"
import script from "./ProjectGalleryDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectGalleryDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGalleryDialog.vue?vue&type=style&index=0&id=0223c0b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0223c0b2",
  null
  
)

export default component.exports